import BasicSprite from "./BasicSprite";
import GervaisSpriteAnimation from "./GervaisSpriteAnimation";
import SpriteAnimation from "./SpriteAnimation";
import SpriteAnimationManager from "./SpriteAnimationManager";
import Spritesheet from "./Spritesheet";

export default class GervaisAnimatedSpritesheet extends Spritesheet {
    /**
     * @param {string} fileName 
     * @param {number} spriteSize 
     * @param {Array.<Object>} spritesheetMetadata
     * @param {number} sheetEndCol
     * @param {SpriteAnimationManager} spriteAnimationManager
     */
    constructor(fileName, spriteSize, spritesheetMetadata, sheetEndCol, spriteAnimationManager) {
        super(fileName, spriteSize);

        /**
         * @constant
         * @type {number}
         */
        this.sheetEndCol = sheetEndCol;
        /**
         * @constant
         * @type {Array.<Object>}
         */
        this.spritesheetMetadata = spritesheetMetadata;
        /**
         * @constant
         * @type {SpriteAnimationManager}
         */
        this.spriteAnimationManager = spriteAnimationManager;

        /**
         * The mapping of sprites by name.
         * @private
         * @type {{}}
         */
        this.spriteMap = {};

        // Tell the superclass to start loading the image.
        this.loadImage();        
    }

    /**
     * @inheritdoc
     * @override
     */
    populateSpriteMap() {

        for (let i = 0; i < this.spritesheetMetadata.length; i++) {
            const datum = this.spritesheetMetadata[i];
            const spriteAnimation = this.loadSpriteAnimation(datum);

            this.spriteMap[datum.animationName] = spriteAnimation;
        }

        this.loaded = true;
    }

    /**
     * @private
     * @param {Object} datum 
     * @returns {SpriteAnimation}
     */
    loadSpriteAnimation(datum) {
        const directionalSprite = Object.hasOwn(datum, 'directional') ? datum.directional : false;
        const fastAnimation = Object.hasOwn(datum, 'fastAnimation') ? datum.fastAnimation : false;
        const superFastAnimation = Object.hasOwn(datum, 'superFastAnimation') ? datum.superFastAnimation : false;

        const spriteFrames = this.createSpriteFrames(datum);

        return new GervaisSpriteAnimation(spriteFrames, this.spriteAnimationManager, fastAnimation, superFastAnimation, directionalSprite);
    }

    /**
     * @private
     * @returns {Array.<Sprite>} 
     */
    createSpriteFrames(datum) {
        const frames = [];

        const startRow = datum.startRow;
        const endRow = datum.endRow;
        const startCol = datum.startCol;
        const endCol = datum.endCol;

        const spriteSize = this.spriteSize;

        for (let row = startRow; row <= endRow; row++) {
            const spriteFrameY = row * spriteSize;

            let endColumn;
            if (row < endRow) {
                endColumn = this.sheetEndCol;
            }
            else {
                endColumn = Math.min(endCol, this.sheetEndCol);
            }

            for (let col = startCol; col <= endColumn; col++) {
                const spriteFrameX = col * spriteSize;
                frames.push(new BasicSprite(this, spriteFrameX, spriteFrameY));
            }
        }

        return frames;
    }


    /**
     * @param {string} name 
     * @returns {GervaisSpriteAnimation}
     */
    getSpriteAnimation(name) {
        return this.spriteMap[name];
    }

}